
if (('.in-index').length) {


    var storredNews = sessionStorage.getItem(document.location.hostname + '-storredNewsData');
    if (storredNews) {
        var storredNews = JSON.parse(storredNews);
        $('.blogWrapper .blogs').html(storredNews);
    } else {
        $.ajax({
            url: '/blog/',
            type: 'GET',
            success: function (response) {
                var content = $(response);
                var newsItems = content.find('.news-item').slice(0, 3);
                var combinedHtml = '';
                newsItems.each(function (index, element) {
                    var $element = $(element);
                    var $elementImage = $element.find('.image img').attr('data-src') || $element.find('.image img').attr('src');
                    var $elementTitle = $element.find('.title').text().trim();
                    var $elementCreated = $element.find('time').text().trim();
                    var $elementLink = $element.find('.title').attr('href');
                    var $elementDescription = $element.find('.description').html();
                    combinedHtml += `
                    <div class="newsItem">
                        <div class="image">
                            <a href="${$elementLink}" class="title">
                                <img src="${$elementImage}">
                            </a>
                        </div>
                        <a href="${$elementLink}" class="text">
                            <span class="created ts">${$elementCreated}</span>
                        
                            <span class="tms title">${$elementTitle}</span>
                            <span class="description ts">${$elementDescription}</span>
                        </a>
                         <a href="${$elementLink}" class="ts link">Číst více</a>
                    </div>
                `;
                });
                $('.blogWrapper .blogs').html(combinedHtml)
                sessionStorage.setItem(document.location.hostname + '-storredNewsData', JSON.stringify(combinedHtml));
            },
            error: function (xhr, status, error) {
                console.error("Error fetching rating data:", status, error);
            }
        }).done(function () {
        });
    }


}


if ($('#newsWrapper').length) {
    $('.news-item').each(function () {
        var $item = $(this);
        $item.find('.text').after(`
                         <a href="${$item.find('.title').attr('href')}" class="ts link">Číst více</a>`)
    })
}